import * as React from "react";
import { TPaymentInstructionPresentationModel } from "../../../presenter/payment/model/PaymentInstructionPresentationModel";
import { PaymentInstructionTypes } from "../../../common/Constants";
import DomesticAbroadInstructionForm from "../../components/payment-instruction/DomesticAbroadInstructionForm";
import DomesticInstructionForm from "../../components/payment-instruction/DomesticInstructionForm";
import AbroadInstructionForm from "../../components/payment-instruction/AbroadInstructionForm";

const PaymentInstructionDetails = ({
  translate,
  paymentInstruction
}: {
  translate: any;
  paymentInstruction?: TPaymentInstructionPresentationModel;
}) => {
  if (!paymentInstruction) return <React.Fragment></React.Fragment>;

  switch (paymentInstruction.type) {
    case PaymentInstructionTypes.UPP:
      return (
        <DomesticInstructionForm
          translate={translate}
          paymentInstruction={paymentInstruction}
        />
      );
    case PaymentInstructionTypes.INO:
      return (
        <AbroadInstructionForm
          translate={translate}
          paymentInstruction={paymentInstruction}
        />
      );
    case PaymentInstructionTypes.UPP_INO:
      return (
        <DomesticAbroadInstructionForm
          translate={translate}
          paymentInstruction={paymentInstruction}
        />
      );
    default:
      return <React.Fragment></React.Fragment>;
  }
};

export default PaymentInstructionDetails;
